"use strict";

//в ие < 9 нет метода трим
if (typeof String.prototype.trim !== 'function') {
  String.prototype.trim = function () {
    return this.replace(/^\s+|\s+$/g, '');
  };
}
;

//форматирует строку, заменяя {<index>} на значения переданного аргумента
String.format = function () {
  var s = arguments[0];
  for (var i = 0; i < arguments.length - 1; i++) {
    var reg = new RegExp("\\{" + i + "\\}", "gm");
    s = s.replace(reg, arguments[i + 1]);
  }
  return s;
};
String.prototype.remove = function (substrForRemove) {
  return this.replace(substrForRemove, '');
};